module.exports = __webpack_public_path__ + "static/media/spinner.1eea3914.svg";